import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Container = styled.div `
  --borderWidth: 3px;
  --borderRadius: ${fluid(4, 12)};

  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  border-radius: var(--borderRadius);
  padding: 16px ${fluid(16, 32)};
  background: linear-gradient(180deg, ${brand.primary.orange} 0%, #a4402c 100%);

  &::after {
    content: '';
    display: block;
    position: absolute;
    background-color: ${brand.primary.white};
    top: var(--borderWidth);
    left: var(--borderWidth);
    height: calc(100% - (var(--borderWidth) * 2));
    width: calc(100% - (var(--borderWidth) * 2));
    z-index: 0;
    border-radius: calc(var(--borderRadius) * 0.85);
  }

  @media ${from(Device.DesktopSmall)} {
    flex-direction: row;
    align-items: center;
  }

  ${ButtonStyles.Container} {
    height: ${fluid(40, 56)};

    position: relative;
    z-index: 1;
  }

  ${ButtonStyles.Text} {
    white-space: nowrap;
  }
`;
const CtaBlockTitle = styled.p `
  ${fonts.poppins.extraBold};

  position: relative;
  z-index: 1;
  font-size: ${fluid(18, 26)};
  line-height: ${fluid(26, 42)};
  margin: 0;
  color: ${brand.primary.orange};
`;
const CtaBlockDescription = styled.div `
  ${fonts.poppins.regular};

  position: relative;
  z-index: 1;
  font-size: ${fluid(14, 22)};
  line-height: ${fluid(20, 36)};
  margin: 8px 0 0;
`;
const CtaBlockStyles = { Container, CtaBlockTitle, CtaBlockDescription };
export default CtaBlockStyles;
